module.exports = __webpack_public_path__ + "static/bsas015-81a507ddf7ca4cab5e6989bb683a568e.jpg";